<template>
  <div id="home" class="hotel_container">
    <Loading :loading="searchLoading" />
    <!-- begin:: Search area -->
    <div class="mod-banner">
      <img src="../assets/img/home_hotel_bg.jpg" class="" alt="bg" />
      <div>
        <div class="mod-banner-search">
          <el-row :gutter="20">
            <div class="col">
              <!-- 目的城市子组件 returnParentValue：给子组件赋值   returnParentValue：子组件返回值（调用方法接收）-->
              <destination
                :returnParentValue="setDestinationVal"
                @returnCityInfo="setDestination"
                :isOnlyCity="false"
              ></destination>
            </div>
            <div class="col">
              <!-- 入住、离店时间子组件 setValue：给子组件赋值   returnCheckDate：子组件返回值（调用方法接收）-->
              <date-picker
                :setValue="setValue"
                @returnCheckDate="setCheckDate"
              ></date-picker>
            </div>
          </el-row>
          <el-row :gutter="20">
            <div class="col">
              <!-- 人数、房间子组件 setRoomNum：房间数，子组件返回值（调用方法接收）   setAdultNum：人数，子组件返回值（调用方法接收）-->
              <Guests
                :roomCount="roomNum"
                :guestCount="guestNum"
                @setRoomNum="setRoomNum"
                @setAdultNum="setGuestNum"
              ></Guests>
            </div>
            <div class="col">
              <KeywordSearch
                @returnKeyWord="returnKeyWord"
                :keywordInput="inputKeyword"
                :isVisible="isVisible"
                :parentCityCode="cityCode"
              ></KeywordSearch>
              <!-- <el-input :placeholder="$t('SEARCH.KEYWORDS')" v-model="inputKeyword" @input="keyInput">
                <svg-icon slot="prefix" icon-class="search" class-name="hotel_input__icon el-icon-search"></svg-icon>
              </el-input> -->
            </div>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-select
                v-show="isOpenTrips"
                :no-data-text="$t('HOME.TRIPSSELECTTIPS')"
                v-model="currSelectIndex"
                class="travel"
                :placeholder="$t('SEARCH.APPROVED')"
                @change="handleTripsOption"
              >
                <template #prefix>
                  <i class="el-input__icon el-icon-postcard trips" aria-hidden="true"></i>
                </template>
                <el-option
                  v-for="(item, tripIndex) in options"
                  :key="item.triporderNo"
                  :label="item.tripPurpose"
                  :value="tripIndex"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <div class="mod-banner-search-btn">
            <div>
              <button
                class="s_btn s_btn_no_round_edge s_btn_large s_btn_large_width"
                @click="toResult('Result')"
              >
                {{ $t("HOME.BUTTONSEARCH") }}
              </button>
              <button  v-if="isOpenTrips" style="margin-left:1rem" class="s_btn s_btn_no_round_edge s_btn_large s_btn_large_width" @click="toResult('Result',true)">{{ $t("HOME.ONLYSEARCH") }}</button>
            </div>
            <div v-if="objBaseInfo.channelId === 'WEB'">
              <a class="a_link" @click="toResult('gaodeMap')">
                <svg-icon
                  icon-class="next"
                  class-name="svg-icon-next"
                ></svg-icon
                >{{ $t("HOME.BUTTONMAP") }}
              </a>
            </div>
            <div v-else>
              <a class="a_link" @click="toResult('MapHotelListMobile')">
                <svg-icon
                  icon-class="next"
                  class-name="svg-icon-next"
                ></svg-icon
                >{{ $t("HOME.BUTTONMAP") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:: Search area -->
    <!-- begin:: Notes area -->
    <div class="mod-notes">
      <div
        class="mod-notes-text"
        v-if="getHtmlNotice[$t('HOME.RESPONSEDATA.notice')]"
      >
        <span class="mod-notes-text-title">{{ $t("HOME.NOTES") }}</span>
        <p v-html="getHtmlNotice[$t('HOME.RESPONSEDATA.notice')]"></p>
      </div>
    </div>
    <!-- end:: Notes area -->
    <!-- 子组件确认框  confirmMsg 提示内容-->
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import "@/icon/svg/next.svg";
import ConfirmBoxs from "../components/confirmBoxs.vue";
import DatePicker from "../components/DatePicker.vue";
import Destination from "../components/Destination.vue";
import Guests from "../components/Guests.vue";
import KeywordSearch from "../components/KeywordSearch.vue";
import { getServerTimeAxios, formatDateTime } from "@/utils/utils.js";
import { searchTravelApplyOrder } from "../api/platformData.js";
import Loading from "@/components/Loading.vue";
import { validateTrip, getCityInfoByCode, isCityGAT,dateChange } from "@/utils/utils";

export default {
  name: "Home",
  components: {
    DatePicker,
    Destination,
    Guests,
    ConfirmBoxs,
    Loading,
    KeywordSearch,
  },
  data() {
    return {
      searchLoading: false,
      userCode: "",
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      inputKeyword: "",
      selTripValue: "",
      options: [],
      setValue: [],
      setDestinationVal: "", //目的城市
      cityCode: "", //目的城市Code
      currSelectIndex: "",
      checkInDate: "", //入住时间
      checkOutDate: "", //离开时间
      roomNum: "", //房间数
      guestNum: "", //人数
      userInfo: {}, //操作人信息
      cityInfo: {}, //目的城市信息
      maxRoom: 0, //最大房间数
      maxAdultRoom: 0, //最大人数
      isOpenTrips: false,
      currentDate: "", //new Date()
      tripNum: 0, //调用次数
      notice: "", //公告
      keywordType: "input", //关键字类型： input 输入 ；auto 带出
      isVisible: true,
      objBaseInfo: {} // 存储全局属性
    };
  },
  computed: {
    getHtmlNotice: function () {
      let objNotice = {};
      for (let item in this.notice) {
        objNotice[item] = this.notice[item]
          ? this.notice[item].replaceAll("\n", "<br></p><p>")
          : "";
      }
      return objNotice;
    },
  },
  watch: {
    "$i18n.locale"() {
      if (this.keywordType == "auto") {
        console.log(this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE"));
        this.inputKeyword =
          this.cityInfo.cityInfo.locationName[
            this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")
          ];
      }
    },
  },
  methods: {
    keyInput() {
      this.keywordType = "input";
    },
    // 关键词搜索返回信息
    returnKeyWord(keyValue) {
      if (keyValue && keyValue.keyword) {
        this.keywordType = keyValue.keywordType;
        if (this.keywordType == "input") {
          this.inputKeyword = keyValue.keyword;
        } else {
          this.cityCode = keyValue.keyword.cityCode;
          this.setDestination({
            cityCode: keyValue.keyword.cityCode,
            cityName:
              keyValue.keyword.cityNameLists[
                this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")
              ],
            cityInfo: keyValue.keyword,
          });
        }
      } else {
        this.keywordType = "input";
        this.inputKeyword = "";
      }
    },
    //获取出差单列表信息
    async getTravelApplyOrderList() {
      this.options = [];
      this.searchLoading = true;
      let travelApplyOrderParam = {
        params: {
          page: 1,
          per_page: 50,
          userCode: this.objBaseInfo.customerCode,
          userID: this.objBaseInfo.loginID,
        },
      };
      await searchTravelApplyOrder(travelApplyOrderParam)
        .then((res) => {
          this.searchLoading = false;
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              console.log(
                "出差单信息请求失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              if (res.data.tripOrderList) {
                let tripOrderList = res.data.tripOrderList;
                let optionTemp = [];
                for (const trip of tripOrderList) {
                  let tripTemp = {
                    tripPurpose: trip.tripPurpose,
                    triporderNo: trip.triporderno, //系统行程单号
                    customerOrderNo: trip.customerOrderNo, //客户行程单号
                    locationCode: trip.location[0].locationCode,
                    checkInDate: trip.location[0].checkInDate ? formatDateTime(trip.location[0].checkInDate,"YYYY-MM-DD"): "",
                    checkOutDate: trip.location[0].checkOutDate ? formatDateTime(trip.location[0].checkOutDate,"YYYY-MM-DD"): "",
                    checkInDateBegin: trip.location[0].checkInDateBegin? formatDateTime(trip.location[0].checkInDateBegin,"YYYY-MM-DD"): "",
                    checkInDateEnd: trip.location[0].checkInDateEnd? formatDateTime(trip.location[0].checkInDateEnd,"YYYY-MM-DD"): "",
                    checkOutBegin: trip.location[0].checkOutBegin? formatDateTime(trip.location[0].checkOutBegin,"YYYY-MM-DD"): "",
                    checkOutEnd: trip.location[0].checkOutEnd? formatDateTime(trip.location[0].checkOutEnd,"YYYY-MM-DD"): "",
                    userID: trip.travelers[0].userID,
                    userName: trip.travelers[0].userName,
                    mobile: trip.travelers[0].mobile,
                    email: trip.travelers[0].email,
                    sex: trip.travelers[0].sex,
                    employeeID: trip.travelers[0].employeeID,
                    costCenter: trip.travelers[0].costCenter,
                    travelers: trip.travelers,
                    location: trip.location,
                    createBy: trip.createBy,
                  };
                  optionTemp.push(tripTemp);
                }
                this.options = optionTemp;
                const selectedTrip = this.objBaseInfo.tripOrderInfo;
                const selectedIndex = selectedTrip
                  ? optionTemp.findIndex(item => item.triporderNo === selectedTrip.triporderNo)
                  : -1;
                if (selectedIndex >= 0) {
                  this.currSelectIndex = selectedIndex;
                  this.handleTripsOption(selectedIndex);
                } else {
                  this.currSelectIndex = "";
                  this.objBaseInfo.tripOrderInfo = null;
                  sessionStorage.removeItem("tripOrder");
                }
              }
            }
          } else {
            console.log("出差单信息请求失败, code:" + res.code, res.message);
          }
        })
        .catch((error) => {
          this.searchLoading = false;
          console.log("出差单信息请求失败" + error.objError);
        });
    },
    // 子组件赋值房间数 guest组件
    setRoomNum(value) {
      this.roomNum = value;
    },
    // 子组件赋值人数 guest组件
    setGuestNum(value) {
      this.guestNum = value;
    },
    // 子组件赋值入住 离店时间 datepicker组件
    setCheckDate(value) {
      if (value != null) {
        this.setValue = value;
        // 入住
        this.checkInDate = formatDateTime(value[0], "YYYY-MM-DD");
        // 离店
        this.checkOutDate = formatDateTime(value[1], "YYYY-MM-DD");
      } else {
        this.setValue = [];
      }
    },
    // 子组件赋值目的城市 destination组件
    setDestination(value) {
      this.cityInfo = value;
      if (value.cityInfo) {
        this.objBaseInfo.countryCode = value.cityInfo.countryCode;
        this.cityCode = value.cityCode;
        this.objBaseInfo.isGATCity = isCityGAT(value.cityInfo.provinceCode);
        this.objBaseInfo.provinceCode = value.cityInfo.provinceCode;
        if (value.cityInfo.locationType != 0) {
          this.keywordType = "auto";
          this.inputKeyword =
            value.cityInfo.locationName[
              this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")
            ];
        } else {
          this.keywordType = "input";
          this.inputKeyword = "";
        }
      } else {
        this.keywordType = "input";
        this.inputKeyword = "";
      }
    },
    // 子组件确认框
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    //路由跳转
    toResult: function (pageName,isOnlySearch) {
      this.objBaseInfo.isOnlySearch = false;
      this.isVisible = !this.isVisible;
      if (
        this.cityInfo.cityCode == undefined ||
        this.cityInfo == null ||
        this.cityInfo.cityCode == ""
      ) {
        this.confirmIcon = "exclamation";
        this.confirmMsg = this.$t("SEARCH.CONFIRMDES");
        this.confirmFlag = true;
      } else if (this.setValue == undefined || this.setValue.length <= 0) {
        this.confirmIcon = "exclamation";
        this.confirmMsg = this.$t("SEARCH.CONFIRMCHECK");
        this.confirmFlag = true;
      } else {
        if(!isOnlySearch){
          //行程单验证
          let msg = validateTrip(
            this,
            this.cityInfo.cityCode,
            this.checkInDate,
            this.checkOutDate
          );
          if (msg != "") {
            this.confirmIcon = "exclamation";
            this.confirmMsg = msg;
            this.confirmFlag = true;
            return false;
          }
        }else{
          this.objBaseInfo.isOnlySearch = true;
        }
        if (!this.judgeCTCiyt()) {
          this.confirmIcon = "exclamation";
          this.confirmMsg = this.$t("HOME.JUDGECTCITYTITLE");
          this.confirmFlag = true;
          return false;
        }
        // 搜索信息参数对象 //city 是json对象 cityName  cityCode
        let searchParam = {
          city: this.cityInfo,
          checkInAt: this.checkInDate,
          checkOutAt: this.checkOutDate,
          roomCount: this.roomNum,
          guestCount: this.guestNum,
          keyword: this.inputKeyword,
          keywordType: this.keywordType,
        };
        if(pageName == "MapHotelListMobile"){
          pageName= "Result";
          searchParam.showMapResult = true;
        }
        // result 页面  map:  页面
        // 跳转页面
        this.$store.commit("changePathQuery", searchParam);
        this.$router.push({
          name: pageName,
          query: {
            searchParam: JSON.stringify(searchParam),
            sourceType: this.objBaseInfo.sourceType,
          },
        });
      }
    },
    handleTripsOption(index) {
      this.cityCode = "";
      let location = this.options[index].location;
      for (const item of location) {
        if (this.objBaseInfo.destinationType == "D" && item.type == 0) {
          this.cityCode = item.locationCode;
          break;
        }
        if (this.objBaseInfo.destinationType == "I" && item.type == 1) {
          this.cityCode = item.locationCode;
          break;
        }
      }
      //强管控
      if (this.objBaseInfo.strongControl == 1 && this.cityCode == "") {
        if (this.objBaseInfo.destinationType == "D") {
          this.confirmMsg = this.$t("SEARCH.DOMESTICAPPROVED");
        } else {
          this.confirmMsg = this.$t("SEARCH.ABROADAPPROVED");
        }
        this.confirmIcon = "exclamation";
        this.confirmFlag = true;
      }
      // 赋值全部city 信息
      getCityInfoByCode(this.cityCode).then((city) => {
        if (city) {
          this.cityInfo.cityCode = city.cityCode;
          this.cityInfo.cityName =
            city.cityNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
          this.setDestinationVal = this.cityInfo.cityName;
          this.cityInfo.cityInfo = city;
          this.objBaseInfo.countryCode = this.cityInfo.cityInfo.countryCode;
          this.objBaseInfo.isGATCity = isCityGAT(
            this.cityInfo.cityInfo.provinceCode
          );
          this.objBaseInfo.provinceCode = this.cityInfo.cityInfo.provinceCode;
        }
      });
      if (
        new Date(this.options[index].checkInDate) < new Date(this.currentDate)
      ) {
        this.options[index].checkInDate = formatDateTime(this.currentDate,"YYYY/MM/DD");
      }
      this.checkInDate = formatDateTime(this.options[index].checkInDate, "YYYY-MM-DD");
      this.checkOutDate = formatDateTime(this.options[index].checkOutDate, "YYYY-MM-DD");
      this.setValue = [
        new Date(this.options[index].checkInDate),
        new Date(this.options[index].checkOutDate),
      ];
      sessionStorage.setItem("tripOrder", JSON.stringify(this.options[index]));
      this.objBaseInfo.tripOrderInfo = this.options[index];
    },
    judgeCTCiyt() {
      let ctCity = this.objBaseInfo.ctCity;
      if (ctCity == undefined || ctCity == null || ctCity == "") {
        return true;
      }
      //判断所选城市是否在国家中屏蔽
      if (ctCity.hasOwnProperty("countryCode")) {
        let countryCode = ctCity.countryCode;
        //排除中国，下边额外判断
        if (
          countryCode.indexOf(this.cityInfo.cityInfo.countryCode) >= 0 &&
          this.cityInfo.cityInfo.countryCode != "100000"
        ) {
          return false;
        }
        //判断所选国家为中国，也屏蔽中国，判断排除是否屏蔽港澳台
        if (
          this.cityInfo.cityInfo.countryCode.indexOf("100000") >= 0 &&
          countryCode.indexOf("100000") >= 0 &&
          ctCity.hasOwnProperty("chinaType")
        ) {
          //屏蔽城市包含港澳
          if (ctCity.chinaType.indexOf(this.cityInfo.cityInfo.provinceCode) >= 0) {
            return false;
          }

          //判断所选是否为台湾城市
          if (
            ctCity.chinaType.indexOf("710000") >= 0 &&
            this.cityInfo.cityInfo.provinceCode.indexOf("710000") >= 0
          ) {
            return false;
          }

          //判断所选是否为大陆城市  排除台湾，香港，澳门
          if (
            ctCity.chinaType.indexOf("100000") >= 0 &&
            this.cityInfo.cityInfo.provinceCode.indexOf("710000") < 0 &&
            this.cityInfo.cityInfo.provinceCode.indexOf("810000") < 0 &&
            this.cityInfo.cityInfo.provinceCode.indexOf("820000") < 0
          ) {
            return false;
          }
        }
      }
      //判断所选城市是否在城市中屏蔽
      if (ctCity.hasOwnProperty("cityCode")) {
        let cityCode = ctCity.cityCode;
        if (cityCode.indexOf(this.cityInfo.cityCode) >= 0) {
          return false;
        }
      }
      return true;
    },
  },
  created() {
    // 获取全局属性
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
      this.notice = this.objBaseInfo.notice || ""; //公告
      this.checkInDate = dateChange(1,  new Date());
      this.checkOutDate = dateChange(2,  new Date());
    }
    
    const hasTripApplyNo = new URLSearchParams(window.location.search).get("tripApplyNo");
    if (!hasTripApplyNo) {
      this.currSelectIndex = "";
      this.objBaseInfo.tripOrderInfo = null;
      sessionStorage.removeItem("tripOrder");
    }
    this.userCode = this.objBaseInfo.userCode;
    this.isStrong = this.objBaseInfo.strongControl; //强弱管控
    this.isOpenTrips = this.objBaseInfo.ordApprovalType == 1 ? true : false; //是否开启行程单
    //行程单获取
    if (this.isOpenTrips) {
      this.$nextTick(() => {
        this.getTravelApplyOrderList();
      });
    }
    if (this.objBaseInfo.channelId === "MOBILE") {
      this.$nextTick(() => {
        //显示回退按钮
        let goHistray = document.querySelector(".van-nav-bar__left");
        if (goHistray) {
          goHistray.removeAttribute("style");
        }
      });
    }
  },
  mounted() {
    if (!this.$route.query.searchParam) {
      //获取当前服务器日期
      getServerTimeAxios((res) => {
        this.currentDate = res;
        this.setValue = [
          dateChange(1, this.currentDate),
          dateChange(2, this.currentDate),
        ];
      });
    } else {
      let searchParam = JSON.parse(this.$route.query.searchParam);
      this.cityCode = searchParam.city.cityCode;
      // 赋值全部city 信息
      getCityInfoByCode(this.cityCode).then((city) => {
        if (city) {
          this.cityInfo.cityCode = city.cityCode;
          this.cityInfo.cityName =
            city.cityNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
          this.cityInfo.cityInfo = city;
          this.objBaseInfo.countryCode = this.cityInfo.cityInfo.countryCode;
          this.objBaseInfo.isGATCity = isCityGAT(
            this.cityInfo.cityInfo.provinceCode
          );
          this.objBaseInfo.provinceCode = this.cityInfo.cityInfo.provinceCode;
        }
      });
      // 入住 离店时间
      this.setValue = [
        formatDateTime(searchParam.checkInAt, "YYYY/MM/DD"),
        formatDateTime(searchParam.checkOutAt, "YYYY/MM/DD"),
      ];
      this.inputKeyword = searchParam.keyword;
      this.roomNum = searchParam.roomCount;
      this.guestNum = searchParam.guestCount;
    }
  },
};
</script>
<style>
.mod-notes-text p {
  text-indent: 2em;
  margin: 0;
}
</style>

<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .mod-notes {
    background-color: #FFFFFF;
    min-height: 267px;
    padding: 2rem 0;
  }

  .mod-notes-text {
    margin: 0rem 1.3rem;

    p {
      display: block;
      font-size: 1.4rem;
      /* font-weight: 600; */
      line-height: 2rem;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 1rem;
    }

    span.mod-notes-text-title {
      height: 3.3rem;
      font-size: 2.4rem;
      /* font-weight: 600; */
      line-height: 3.3rem;
      margin-bottom: 2.5rem;
    }
  }

  .col {
    width: 100%;
    margin-bottom: 10px;
  }

  .mod-banner-search {
    position: absolute;
    top: 5%;
    left: 3%;
    background-color: rgba(51, 63, 72, 0.5);
    /* max-width: 1320px;
    max-height: 315px; */
    width: 90%;
    padding: 2%;
  }

  :deep(.el-input__inner) {
    height: 4.5rem;
    line-height: 4.5rem;
    background-color: #E7E9EA;
  }

  :deep(.van-calendar__day) {
    height: 6rem;
    font-size: 1.2rem;
  }

  :deep(.van-calendar__bottom-info), :deep(.van-calendar__top-info) {
    font-size: 1rem;
    line-height: 1.2rem;
  }

  :deep(.van-popup)::-webkit-scrollbar {
    width: 0px;
  }

  :deep(.van-index-bar__index) {
    margin-bottom: 0.5rem;
  }
  :deep(.el-input__wrapper) {
    background-color: #E7E9EA;
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .mod-notes {
    background-color: #FFFFFF;
    min-height: 267px;
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .mod-notes-text {
    max-width: 1320px;
    // max-height: 238px;
    height: 100%;
    background: #FFFFFF;
    border-radius: 0.4rem;
    border: 1px solid $bg-color;
    margin: 0 6rem;
    padding: 3rem;

    p {
      display: block;
      font-size: 1.4rem;
      /* font-weight: 600; */
      line-height: 2rem;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 1rem;
    }

    span.mod-notes-text-title {
      height: 3.3rem;
      font-size: 2.4rem;
      font-weight: 600;
      line-height: 3.3rem;
      margin-bottom: 2.5rem;
    }
  }

  .col {
    width: 50%;
    margin-bottom: 20px;
  }

  .mod-banner-search {
    position: absolute;
    top: 10%;
    left: 3%;
    background-color: rgba(51, 63, 72, 0.5);
    /* max-width: 1320px;
    max-height: 315px; */
    width: 90%;
    height: 70%;
    padding: 2%;
  }

  .a_link {
    margin-top: -2rem;
  }

  :deep(.el-input__wrapper) {
    height: 5rem;
    line-height: 5rem;
    background-color: #E7E9EA;
  }
}

.col {
  padding: 0 10px;
  float: left;
  box-sizing: border-box;
}

.mod-banner {
  height: 44rem;
  position: relative;

  img {
    max-width: 1440px;
    width: 100%;
    height: 100%;
  }
}

.mod-banner-search-btn {
  width: 100%;
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}

// .el-row {
// margin-bottom: 20px;

// &:last-child {
// margin-bottom: 0;
// }
// }
.svg-icon-next {
  font-size: 2.4rem;
  margin-right: 1rem;
}

.a_link {
  color: #fff;
  font-size: 1.8rem;
  height: 2.5rem;
  line-height: 2.5rem;
  cursor: pointer;
}

.trips {
  font-weight: 600;
  color: $font-color;
  font-size: 2.4rem;
  height: 5rem;
  line-height: 5rem;
}

// :deep(.el-input__inner) {
// height: 5rem;
// line-height: 5rem;
// background-color: #E7E9EA;
// }
:deep(.el-range-editor .el-range-input) {
  background-color: #E7E9EA;
}

:deep(.el-input--prefix .el-input__inner) {
  padding-left: 10px;
}

:deep(.el-select) {
  width: 100%;
}
:deep(.el-select__wrapper){
  height: 5rem;
}
</style>